import { UserClaimTypes, UserManager } from "app/core";
import { UniversalAppShell } from "component-library";
import React, { PropsWithChildren, useEffect } from "react";
import { matchPath, Outlet, useLocation } from "react-router-dom";
import { useSupportChat } from "shared-hooks";
import { GlobalEventTypes } from "contexts/GlobalContext";
import ProfileMiniFooter from "components/common/ProfileFooter";
import { CommonSection } from "sections/CommonSection";
import { config } from "config";
import {
  IGlobalContextProps,
  withGlobalContext,
} from "shared/contexts/GlobalContext";
import compose from "shared/utils/compose";
import withPathsFilmmakersAccessRestriction from "app/hoc/withPathsFilmmakersAccessRestriction";
import {
  EDIT_AUDIO_FULL_PATH,
  EDIT_VIDEO_FULL_PATH,
  MEDIA_ADD_FULL_PATH,
  MEDIA_FULL_PATH,
  VIEW_PIN_PATTERN,
} from "app/config/routes";

const MasterPage = ({
  globalContext,
}: PropsWithChildren<IGlobalContextProps>) => {
  const location = useLocation();

  useSupportChat(location.pathname, undefined, config.supportChatBotId);

  useEffect(() => {
    globalContext.notifyListener(
      GlobalEventTypes.makeVisibleGlobalSpinner,
      false
    );

    return () => {
      UserManager.setClaim(UserClaimTypes.userId, "");
    };
  }, []);

  const isPublicProfilePage = VIEW_PIN_PATTERN.test(location.pathname);
  const mediaPages = [
    MEDIA_FULL_PATH,
    MEDIA_ADD_FULL_PATH,
    EDIT_VIDEO_FULL_PATH,
    EDIT_AUDIO_FULL_PATH,
  ];

  const isMediaPage = mediaPages.some((path) =>
    matchPath({ path, end: true }, location.pathname)
  );

  return (
    <UniversalAppShell
      footerComponent={isPublicProfilePage && <ProfileMiniFooter />}
      hideFooter={!isMediaPage}
    >
      <div id="content-container">
        <div className="a-master-page__hidden-panel" />
        <Outlet />
      </div>
      <CommonSection />
    </UniversalAppShell>
  );
};

export default compose(
  withGlobalContext,
  withPathsFilmmakersAccessRestriction([
    "/profile/linktoprofile",
    "/profile/myviewpin",
  ])
)(MasterPage);
